import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPlus,
    faExchangeAlt,
    faToggleOn,
    faCut,
    faLayerGroup,
    faPencilAlt,
} from '@fortawesome/free-solid-svg-icons';

const ACTIONS = [
    {
        key: 'createNew',
        icon: faPlus,
        label: 'Create New Program',
        description: 'Create a new program and generate a new program ID',
    },
    {
        key: 'consolidate',
        icon: faLayerGroup,
        label: 'Consolidate Programs',
        description: 'At least two or more existing programs → one new program and program ID',
    },
    {
        key: 'changeDetails',
        icon: faPencilAlt,
        label: 'Change Details',
        description: 'Name, CIP, hours, delivery, etc.',
    },
    {
        key: 'merge',
        icon: faExchangeAlt,
        label: 'Merge Programs',
        description: 'Combine one program into another',
    },
    {
        key: 'changeStatus',
        icon: faToggleOn,
        label: 'Change Status',
        description: 'Eliminate, suspend, or reinstate',
    },
    {
        key: 'split',
        icon: faCut,
        label: 'Split a Program',
        description: 'Divide one program into two or more to generate at least one new program and Program ID',
    },
];

export const ActionSelectionScreen = ({ onSelect }) => (
    <div>
        <p className="mb-4">What would you like to do?</p>
        <div className="row">
            {ACTIONS.map(({ key, icon, label, description }) => (
                <div key={key} className="col-6 mb-3">
                    <div
                        className="card h-100 border"
                        role="button"
                        tabIndex={0}
                        onClick={() => onSelect(key)}
                        onKeyPress={(e) => e.key === 'Enter' && onSelect(key)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="card-body">
                            <div className="mb-2">
                                <FontAwesomeIcon
                                    icon={icon}
                                    size="lg"
                                    className="text-primary mr-2"
                                />
                                <strong>{label}</strong>
                            </div>
                            <p className="card-text text-muted small mb-0">
                                {description}
                            </p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
);
